import { render, staticRenderFns } from "./Webhook.vue?vue&type=template&id=a5480b98"
import script from "./Webhook.vue?vue&type=script&setup=true&lang=ts"
export * from "./Webhook.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports